import type { Directive } from 'vue'

/**
 * `v-reveal` : l'élément apparaît en douceur quand il entre à l'écran (une seule fois).
 * `v-reveal="120"` décale l'apparition de 120 ms (cartes en cascade).
 * Sans IntersectionObserver (vieux navigateurs, rendu de test), l'élément est visible d'emblée.
 */
export const vReveal: Directive<HTMLElement, number | undefined> = {
  mounted(element, binding) {
    if (typeof IntersectionObserver === 'undefined') return
    element.classList.add('reveal')
    if (binding.value) element.style.setProperty('--reveal-delay', `${String(binding.value)}ms`)
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
    )
    observer.observe(element)
  },
}

declare module 'vue' {
  interface GlobalDirectives {
    vReveal: typeof vReveal
  }
}
